import constant from "../_config/constant";
import { authHeader } from "../_helpers";
import { history } from "../_helpers/history";
import { handleResponse } from "../_helpers/utils";
import { apiAdminClient } from "../_lib/apiClient";

export const propertyService = {
  list,
  add,
  allPropertylist,
  update,
  updateStatus,
  // logout,
  getDetail,
  _update,
  updatePhoto,
  saveAsDraft,
  bookingDetail,
  bookinglist,
  sendPaymentReminderMail,
  updateBookingStatus,
  cancelBookingByHost,
  cancelBookingByAdmin,
  cancelBookingByDate,
  adminCancelBookingBeforeCheckIn,
  AdminCancelBookingByDate,
  bookingRefundStatus,
  isRoomDeletableService,
  handleFeaturedService,
  exportProperties,
  exportReservations,
  cancelBookingByDateAdmin,
  partialRefund,
};

async function preparePropertyPhotos(photos) {
  const oldFiles = [];
  const newFiles = [];

  [...(photos || [])]
    .sort((left, right) => left.order - right.order)
    .forEach((file) => {
      if (file.type === "url") {
        oldFiles.push(file);
      } else {
        newFiles.push(file);
      }
    });

  const uploadedNames = [];
  for (let offset = 0; offset < newFiles.length; offset += 10) {
    const batch = newFiles.slice(offset, offset + 10);
    const uploadBody = new FormData();
    batch.forEach((file) => {
      uploadBody.append("files", file.current);
      uploadBody.append("orders", file.order);
    });
    const response = await fetch(`${constant.apiUrl}/property/upload/photo`, {
      method: "POST",
      headers: { ...authHeader() },
      body: uploadBody,
    });
    const result = await handleResponse(response);
    uploadedNames.push(...result.data.filenames);
  }

  uploadedNames.forEach((url, index) => {
    oldFiles.push({
      type: "url",
      id: url,
      url,
      order: newFiles[index].order ?? index + 1,
    });
  });
  return oldFiles.sort((left, right) => left.order - right.order);
}


async function exportReservations  (query) { 
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetch(`${constant.apiUrl}/booking/export?${new URLSearchParams(query).toString()}`, requestOptions);
    if (!response.ok) {
      throw new Error('Failed to export Reservations');
    }
    const blob = await response.blob();
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = 'reservations.csv';
    anchor.click();

    console.log('CSV file download initiated');
  } catch (error) {
    console.error('Failed to export reservations', error);
  }
 }

async function exportProperties(search,state){
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetch(`${constant.apiUrl}/property/export?search=${search}&selectedState=${state}`, requestOptions);
    if (!response.ok) {
      throw new Error('Failed to export properties');
    }
    const blob = await response.blob();
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = 'properties.csv';
    anchor.click();

    console.log('CSV file download initiated');
  } catch (error) {
    console.error('Failed to export properties', error);
  }
}

function list(data) {
  console.log(data,"adata--")
  data.sort = data.sort ? data.sort : 0 ;
  data.isSort = data.isSort ? data.isSort : 0 ;
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  console.log("me called ============+++++++++++++++++++", requestOptions)
  return fetch(
    `${constant.apiUrl}/property/list?search=${data.search}&page=${data.page}&limit=${data.limit}&selectedState=${data.selectedState}&status=${data.selectedStatus}&isSort=${data.isSort}&&sort=${data.sort}`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

async function handleFeaturedService(id) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  };
  const response = await fetch(
    `${constant.apiUrl}/property/handleFeatured`,
    requestOptions
  );
  const data = await handleResponse(response);
  return data;
}

function allPropertylist() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/property/all`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function updateStatus(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/property/updateStatus`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

async function add(data) {
  var location = Object.values(data.location);
  var fd = new FormData();
  fd.append("aboutListing", data.aboutListing);
  fd.append("accomodationCapacity", data.accomodationCapacity);
  fd.append("address", data.address);
  fd.append("amenities", JSON.stringify(data.amenities));
  fd.append("bookingType", data.bookingType);
  fd.append("cancelationPolicy", data.cancelationPolicy);
  fd.append("cleaningFee", data.cleaningFee);
  fd.append("listingName", data.listingName);
  fd.append("parking", data.parking);
  fd.append("perMonthPrice", data.perMonthPrice);
  fd.append("perNightPrice", data.perNightPrice);
  fd.append("propertyType", data.propertyType);
  fd.append("rentalType", data.rentalType);
  fd.append("safety", JSON.stringify(data.safety));
  fd.append("securityDeposite", data.securityDeposite);
  fd.append("sleepingArrangements", JSON.stringify(data.sleepingArrangements));
  fd.append("transportation", data.transportation);
  fd.append("stayLimit", data.stayLimit ? data.stayLimit : "");
  fd.append("reservedDays", data.reservedDays ? data.reservedDays : "");
  fd.append("lineholderDays", data.lineholderDays ? data.lineholderDays : "");
  fd.append(
    "lineholderDiscountType",
    data.lineholderDiscountType ? data.lineholderDiscountType : ""
  );
  fd.append(
    "lineholderDiscount",
    data.lineholderDiscount ? data.lineholderDiscount : ""
  );
  fd.append("covidVerified", data.covidVerified);
  fd.append("location", JSON.stringify(location.reverse()));
  fd.append("hostId", data.hostId);
  fd.append("extraChargePerGuest", data.extraChargePerGuest);
  fd.append("houseRules", JSON.stringify(data.houseRules));
  fd.append(
    "apartmentNumber",
    data.apartmentNumber ? data.apartmentNumber : ""
  );
  fd.append("propertyId", data.propertyId ? data.propertyId : "");
  fd.append("photosExist", "photos" in data);

  // data.photos.forEach((file) => { fd.append('files', file.current); })

  const oldFIle = await preparePropertyPhotos(data.photos);
  fd.append("oldFIle", JSON.stringify(oldFIle));
  fd.append("newFileOrder", JSON.stringify([]));

  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: fd,
  };

  return fetch(`${constant.apiUrl}/property/add`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

async function update(data) {
  var location = Object.values(data.location);
  var fd = new FormData();
  fd.append("aboutListing", data.aboutListing);
  fd.append("accomodationCapacity", data.accomodationCapacity);
  fd.append("address", data.address);
  fd.append("amenities", JSON.stringify(data.amenities));
  fd.append("bookingType", data.bookingType);
  fd.append("cancelationPolicy", data.cancelationPolicy);
  fd.append("cleaningFee", data.cleaningFee);
  fd.append("houseRules", JSON.stringify(data.houseRules));
  fd.append("listingName", data.listingName);
  fd.append("parking", data.parking);
  fd.append("perMonthPrice", data.perMonthPrice);
  fd.append("perNightPrice", data.perNightPrice);
  fd.append("propertyType", data.propertyType);
  fd.append("rentalType", data.rentalType);
  fd.append("safety", JSON.stringify(data.safety));
  fd.append("securityDeposite", data.securityDeposite);
  fd.append("sleepingArrangements", JSON.stringify(data.sleepingArrangements));
  fd.append("transportation", data.transportation);
  fd.append("stayLimit", data.stayLimit ? data.stayLimit : "");
  fd.append("reservedDays", data.reservedDays ? data.reservedDays : "");
  fd.append("lineholderDays", data.lineholderDays ? data.lineholderDays : "");
  fd.append(
    "lineholderDiscountType",
    data.lineholderDiscountType ? data.lineholderDiscountType : ""
  );
  fd.append(
    "lineholderDiscount",
    data.lineholderDiscount ? data.lineholderDiscount : ""
  );
  fd.append("covidVerified", data.covidVerified);
  fd.append("location", JSON.stringify(location.reverse()));
  fd.append("hostId", data.hostId);
  fd.append("extraChargePerGuest", data.extraChargePerGuest);
  fd.append("propertyId", data.propertyId);
  fd.append("apartmentNumber", data.apartmentNumber);

  const oldFIle = await preparePropertyPhotos(data.photos);
  fd.append("oldFIle", JSON.stringify(oldFIle));
  fd.append("newFileOrder", JSON.stringify([]));

  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: fd,
  };
  return fetch(`${constant.apiUrl}/property/update`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function _update(data) {
  if (data.location) {
    data.location = data.location.reverse();
  }
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(`${constant.apiUrl}/property/_update`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}
async function isRoomDeletableService(roomId) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ roomId }),
  };

  return fetch(`${constant.apiUrl}/property/is_room_deletable`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

async function updatePhoto(data) {
  var fd = new FormData();
  fd.append("propertyId", data.propertyId);
  const oldFIle = await preparePropertyPhotos(data.photos);
  fd.append("oldFIle", JSON.stringify(oldFIle));
  fd.append("newFileOrder", JSON.stringify([]));
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: fd,
  };
  return fetch(`${constant.apiUrl}/property/update/photo`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

async function saveAsDraft(data) {
  var location = data.location ? Object.values(data.location) : [];
  var fd = new FormData();

  fd.append("aboutListing", data.aboutListing ? data.aboutListing : "");
  fd.append(
    "accomodationCapacity",
    data.accomodationCapacity ? data.accomodationCapacity : ""
  );
  fd.append("address", data.address ? data.address : "");
  fd.append("bookingType", data.bookingType ? data.bookingType : "");
  fd.append(
    "cancelationPolicy",
    data.cancelationPolicy ? data.cancelationPolicy : ""
  );
  fd.append("cleaningFee", data.cleaningFee ? data.cleaningFee : "");
  fd.append("listingName", data.listingName ? data.listingName : "");
  fd.append("parking", data.parking ? data.parking : "");
  fd.append("perMonthPrice", data.perMonthPrice ? data.perMonthPrice : "");
  fd.append("perNightPrice", data.perNightPrice ? data.perNightPrice : "");
  fd.append("propertyType", data.propertyType ? data.propertyType : "");
  fd.append("rentalType", data.rentalType ? data.rentalType : "");
  fd.append(
    "securityDeposite",
    data.securityDeposite ? data.securityDeposite : ""
  );
  fd.append("transportation", data.transportation ? data.transportation : "");
  fd.append("stayLimit", data.stayLimit ? data.stayLimit : "");
  fd.append("reservedDays", data.reservedDays ? data.reservedDays : "");
  fd.append("lineholderDays", data.lineholderDays ? data.lineholderDays : "");
  fd.append(
    "lineholderDiscountType",
    data.lineholderDiscountType ? data.lineholderDiscountType : ""
  );
  fd.append(
    "lineholderDiscount",
    data.lineholderDiscount ? data.lineholderDiscount : ""
  );
  fd.append("covidVerified", data.covidVerified ? data.covidVerified : "");
  fd.append(
    "extraChargePerGuest",
    data.extraChargePerGuest ? data.extraChargePerGuest : ""
  );
  fd.append("propertyId", data.propertyId ? data.propertyId : "");
  fd.append(
    "apartmentNumber",
    data.apartmentNumber ? data.apartmentNumber : ""
  );
  fd.append("hostId", data.hostId ? data.hostId : "");
  fd.append("photosExist", "photos" in data);

  if (data.sleepingArrangements && data.sleepingArrangements.length) {
    fd.append(
      "sleepingArrangements",
      JSON.stringify(data.sleepingArrangements)
    );
  }
  if (location && location.length) {
    fd.append("location", JSON.stringify(location.reverse()));
  }
  if (data.safety && data.safety.length) {
    fd.append("safety", JSON.stringify(data.safety));
  }
  if (data.houseRules && data.houseRules.length) {
    fd.append("houseRules", JSON.stringify(data.houseRules));
  }
  if (data.amenities && data.amenities.length) {
    fd.append("amenities", JSON.stringify(data.amenities));
  }

  const oldFIle = await preparePropertyPhotos(data.photos);
  fd.append("oldFIle", JSON.stringify(oldFIle));
  fd.append("newFileOrder", JSON.stringify([]));

  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: fd,
  };
  return fetch(`${constant.apiUrl}/property/saveasdraft`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function getDetail(id) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/property/detail/${id}`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function bookinglist(query) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${constant.apiUrl}/booking?${new URLSearchParams(query).toString()}`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function updateBookingStatus({ id, status, reason }) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId: id, status , reason }),
  };
  console.log("Testing admin   ==============");
  return fetch(`${constant.apiUrl}/booking/updateStatus`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function cancelBookingByHost(bookingId) {
  console.log("Testing cancelBookingByHost ==============");
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId }),
  };
  return fetch(`${constant.apiUrl}/booking/cancelBookingByHost`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function adminCancelBookingBeforeCheckIn(bookingId) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId }),
  };
  return fetch(`${constant.apiUrl}/booking/cancelBookingByDate`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function cancelBookingByAdmin(bookingId) {
  console.log("Testing cancelBookingByHost ==============");
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId }),
  };
  return fetch(
    `${constant.apiUrl}/booking/cancelBookingByAdmin`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function cancelBookingByDate(bookingId, cancelDate, isCancelByAdmin) {
  console.log("Testing cancelBookingByHost ==============");
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId, cancelDate, isCancelByAdmin }),
  };
  return fetch(`${constant.apiUrl}/booking/cancelBookingByDate`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function isValidDateOnly(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));

  return parsed.getUTCFullYear() === year
    && parsed.getUTCMonth() === month - 1
    && parsed.getUTCDate() === day;
}

function adminBookingCancellationError(error) {
  const body = error?.response?.data;
  const commandError = new Error(
    body?.message
      || body?.userMessage
      || error?.message
      || "Reservation cancellation could not be completed."
  );
  commandError.statusCode = body?.statusCode ?? error?.response?.status;
  commandError.code = body?.code;
  commandError.data = body?.data;
  return commandError;
}

async function cancelBookingByDateAdmin(bookingId, cancelDate) {
  const normalizedBookingId = String(bookingId || "").trim();
  const normalizedCancelDate = String(cancelDate || "").trim();

  if (!normalizedBookingId) {
    const invalidBooking = new Error("A reservation is required for cancellation.");
    invalidBooking.code = "booking_id_required";
    throw invalidBooking;
  }
  if (!isValidDateOnly(normalizedCancelDate)) {
    const invalidDate = new Error("Enter a valid cancellation date in YYYY-MM-DD format.");
    invalidDate.code = "cancel_date_invalid";
    throw invalidDate;
  }

  try {
    const response = await apiAdminClient.post("/booking/cancelBookingByDate", {
      bookingId: normalizedBookingId,
      cancelDate: normalizedCancelDate,
    });
    const body = response?.data;
    const message = typeof body?.message === "string" ? body.message.trim() : "";
    const deferred = message === "Please try again in 5 minutes";

    if (!body || body.status !== true || Number(body.statusCode) !== 200 || deferred) {
      const invalidResponse = new Error(
        message || "Reservation cancellation returned an invalid response."
      );
      invalidResponse.response = {
        status: body?.statusCode,
        data: deferred
          ? { ...body, status: false, code: body?.code || "booking_cancellation_deferred" }
          : body,
      };
      throw invalidResponse;
    }

    return body;
  } catch (error) {
    throw adminBookingCancellationError(error);
  }
}

function AdminCancelBookingByDate(bookingId, cancelDate, isCancelByAdmin) {
  console.log("Testing cancelBookingByHost ==============");
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ bookingId, cancelDate, isCancelByAdmin }),
  };
  return fetch(`${constant.apiUrl}/booking/cancelBookingByDate`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function bookingDetail(id) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/booking/${id}`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function bookingRefundStatus({ bookingId }) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader() },
  };
  return fetch(`${constant.apiUrl}/refund/${bookingId}`, requestOptions)
    .then(handleResponse)
    .then((refundData) => {
      return refundData;
    });
}

function partialRefund({ commissionId, amount, idempotencyKey }) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json", "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ commissionId, amount }),
  };
  return fetch(`${constant.apiUrl}/refund/partial`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

// function logout() {
//   // remove user from local storage to log user out
//   localStorage.removeItem(constant.TOKEN_KEY);
//   localStorage.removeItem(constant.DATA_KEY);
// }

// function handleResponse(response) {
//   return response.text().then((text) => {
//     const data = text && JSON.parse(text);

//     if (data.statusCode == 401 || data.statusCode == 403) {
//       logout();
//       window.location.reload();
//     }
//     if (data.statusCode != 200) {
//       const error = (data && data.userMessage) || response.statusText;
//       return Promise.reject(error);
//     }
//     return data;
//   });
// }

function sendPaymentReminderMail(req) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  return fetch(`${constant.apiUrl}/property/mail`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

// function cancelBookingByHost({ bookingId }) {

//   const requestOptions = {
//     method: "POST",
//     headers: { ...authHeader(), "Content-Type": "application/json" },
//     body: JSON.stringify({ bookingId }),
//   };
//   return fetch(`${constant.apiUrl}/booking/cancelBookingByHost`, requestOptions)
//     .then(handleResponse)
//     .then((user) => {
//       return user;
//     });
// }
